import {useEffect, useState} from "react";
import {readStorage} from "../utils/storage";

// the value stored under `key`, kept up to date when it is written, see utils/storage
export const useStorageData = (key: string, defaultState: string | null = null) => {
  const [data, setData] = useState(() => readStorage<any>(key, defaultState));

  useEffect(() => {
    const handleChangeStorage = () => {
      setData(readStorage(key, defaultState));
    }

    window.addEventListener('storage', handleChangeStorage);
    return () => window.removeEventListener('storage', handleChangeStorage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return data;
}
